import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../providers/appsyncservice/aws.service';
import { identifierModuleUrl } from '@angular/compiler';
import * as XLSX from 'xlsx/types';
import { GoogleMapsAPIWrapper, MapsAPILoader } from '@agm/core';
import { Observable } from 'rxjs';
import { positions } from '../../models/positions'
import { GlobalSearchPipe } from '../../pipes/global-search.pipe';
declare var google: any;
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { InfoServiceService } from '../../service/rightinfo/info-service.service';
import { AppConstants } from '../../constants/app-constants';

@Component({
  selector: 'app-remainingscreen',
  templateUrl: './remainingscreen.component.html',
  styleUrls: ['./remainingscreen.component.css']
})
export class RemainingscreenComponent implements OnInit {

  triplist = [];
  upcoming: any
  searchText: string
  nextToken: String = "";

  constructor(public awserviceProvider: AwsService, private infoService: InfoServiceService) {
    infoService.setUrl(AppConstants.REMAINING_SCREEN);
    this.searchText = "";
    this.scheduledTrips();

  }

  ngOnInit() {
    this.upcoming = [];
    this.searchText = "";
  }

  async scheduledTrips() {
    let dateFormat = require('dateformat');
    let now = new Date();
    let gecondition = dateFormat(now, "yyyy-mm-dd");

    let nextday = new Date();
    nextday.setDate(nextday.getDate() + 2);
    let lecondition = dateFormat(nextday, "yyyy-mm-dd");


    await this.awserviceProvider.getTripsByStatusNextToken(0, lecondition, gecondition, this.nextToken).then(async (res: any) => {

      if (res.nextToken != null) {
        this.nextToken = res.nextToken;
        console.log("this.nextToken", this.nextToken)
        this.scheduledTrips();
      }
      let remaininglist: any = res;

      await remaininglist.forEach(trip => {
        trip.loc = {}
        trip.driver = {};
        this.awserviceProvider.getUserTripByDriverId(trip.id, trip.driver_id).then(async usertrip => {
          trip.start_address = usertrip[0].start_address.address;
          trip.end_address = usertrip[0].end_address.address;
        })
        this.awserviceProvider.getRncUsers(trip.driver_id).then(async driver => {

          trip.driver = driver[0];
        })
        this.upcoming.push(trip);
        this.searchText = "";

      })
    });
  }
}

